import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { initializeApp } from 'firebase/app';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, Subject, of } from 'rxjs';
// import { Firestore, collectionData, getDocs } from '@angular/fire/firestore';
import { Firestore, collection, doc, getDoc, getDocs, onSnapshot, query, setDoc, where } from "firebase/firestore";

import { getFirestore } from "firebase/firestore";
import { getDatabase, ref, set, onValue, off, remove, onDisconnect, serverTimestamp } from "firebase/database";
import { AuthServiceService } from './auth-service.service';
import { ToastService } from './toast.service';

// TODO: Replace the following with your app's Firebase project configuration
// See: https://support.google.com/firebase/answer/7015592


// Initialize Firebase
const app = initializeApp(environment.firebase);


// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);
const rtdb = getDatabase(app);

@Injectable({
    providedIn: 'root',
})
export class LocateDriverService {
    public docIds: any = [];
    organizationId:any;
    _liveApiUrl: any = this.authService._liveApiUrl;
    private updateSubject: Subject<any> = new Subject<any>();
    public driverData: any = [];
    
    // RTDB Tracking state
    private activeWatcherInterval: any;
    private currentAdminSessionId: string | null = null;
    private currentTrackedDriverId: string | null = null;
    private rtdbUnsubscribe: any;
    private visibilityListenerBound = false;
    private currentTargetDriverName: string = 'Unknown Driver';
    private firestoreUnsubscribe: any = null;

    private handleVisibilityChange = () => {
        if (document.hidden) {
            this.pauseHeartbeat();
        } else {
            if (this.currentTrackedDriverId && this.organizationId) {
                const currentWatcherRef = ref(rtdb, `active_watchers/${this.organizationId}/${this.currentTrackedDriverId}/${this.currentAdminSessionId}`);
                const adminEmail = this.authService.getLS('org_email') || 'Unknown Admin';
                const orgName = this.authService.getLS('org_domain') || 'Unknown Org';
                const payload = {
                    timestamp: serverTimestamp(),
                    readableTime: new Date().toLocaleString(),
                    watcherId: adminEmail,
                    role: `Admin Portal: ${adminEmail}`,
                    orgName: orgName,
                    targetDriverName: this.currentTargetDriverName
                };
                this.resumeHeartbeat(currentWatcherRef, payload);
            }
        }
    };

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private http: HttpClient,
        private toastr: ToastrService,
        private authService: AuthServiceService,
         private toast: ToastService,
    ) {
         const currentUrl = this.router.url;
       if (currentUrl.includes('admin') && !currentUrl.includes('receiving-admin')) {
         this.listenForUpdates();
       }
       else if (currentUrl.includes('receiving-admin')) {
          const storedPayload = localStorage.getItem('companyDriverPayload');
            let companyDriverPayload = storedPayload ? JSON.parse(storedPayload) : [];
        
            // 🔹 2. Transform nested → flat
            const formattedPayload = companyDriverPayload.map((company: any) => ({
              company_id: company.company_id,
              driver_ids: company.driver_ids.map((d: any) => d[0]) // 👈 "14-31"
            }));
            if (!companyDriverPayload || companyDriverPayload.length === 0) {
this.toast.show(
  'warning',
  'No enroute drivers available to display on the map. Please assign drivers to the order and mark them as enroute, then try again.'
);  return;
}
         this.listenDriversByCompanies(formattedPayload);
       }
        
        // this.getDriversInfo();
    }

    async getDriversInfo() {
           this.docIds = [];
    this.driverData = [];
        this.organizationId =this.authService.getLS('org_Id');
        const q = query(collection(db, "users"));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            const docOrgId = doc.id.split('-')[0];
    if (docOrgId === this.organizationId) {
        this.docIds.push(doc.id);
        this.driverData.push(doc.data());
    }
        });
        return this.driverData;
    }
    async getDriversInfoByCompanies(companiesData: any[]) {

  this.docIds = [];
  this.driverData = [];

  const q = query(collection(db, "users"));
  const querySnapshot = await getDocs(q);

  // 🔥 Fast lookup ke liye driver set
  const driverSet = new Set();

  companiesData.forEach(company => {
    company.driver_ids.forEach((id: string) => {
      driverSet.add(id);
    });
  });

  querySnapshot.forEach((doc) => {
    const docId = doc.id;

    // ✅ sirf wahi drivers lo jo payload me hain
    if (driverSet.has(docId)) {
      this.docIds.push(docId);

      this.driverData.push({
        ...doc.data(),
        driver_id: docId   // optional (helpful for map)
      });
    }
  });

  return this.driverData; // 👈 SAME FORMAT (flat array)
}

    listenForUpdates() {
        this.organizationId = this.authService.getLS('org_Id');
        
        // Clear existing data before fetching updated data
        this.docIds = [];
        this.driverData = [];
    
        const q = query(collection(db, "users"));
        
        if (this.firestoreUnsubscribe) {
            this.firestoreUnsubscribe();
            this.firestoreUnsubscribe = null;
        }
        
        // Listen to real-time updates
        this.firestoreUnsubscribe = onSnapshot(q, (querySnapshot) => {
            querySnapshot.docChanges().forEach((change) => {
                const docOrgId = change.doc.id.split('-')[0];
    
                // Check if the updated document belongs to the current organization
                if (docOrgId === this.organizationId) {
                    if (change.type === "added") {
                        // Add newly added document
                        this.docIds.push(change.doc.id);
                        this.driverData.push(change.doc.data());
                    }
                    if (change.type === "modified") {
                        // Update existing document
                        const index = this.docIds.indexOf(change.doc.id);
                        if (index !== -1) {
                            const driverId = change.doc.id.split('-')[1];
                            const newData: any = change.doc.data();
                            newData['driver_id'] = driverId;
                            
                            // Capture the fresh time from Firestore before we overwrite the location
                            const freshFirestoreTime = newData.location?.updatedTime;
                            
                            // 🔹 Guard against stale Firestore location overwriting fresh RTDB location
                            if (this.currentTrackedDriverId === driverId && this.activeWatcherInterval) {
                                if (this.driverData[index] && this.driverData[index]['location']) {
                                    // Clone the live RTDB location so the truck doesn't snap backward...
                                    const liveLocation = { ...this.driverData[index]['location'] };
                                    // ...but inject the fresh Firestore timestamp so the UI label stays accurate!
                                    if (freshFirestoreTime) {
                                        liveLocation.updatedTime = freshFirestoreTime;
                                    }
                                    newData['location'] = liveLocation;
                                }
                            }
                            
                            this.driverData[index] = newData;
                            
                            // If actively tracking, suppress emitting the full Firestore payload to avoid map reset
                            if (this.currentTrackedDriverId !== driverId || !this.activeWatcherInterval) {
                                this.updateSubject.next(this.driverData[index]);
                            }
                        }
                    }
                    if (change.type === "removed") {
                        // Remove deleted document
                        const index = this.docIds.indexOf(change.doc.id);
                        if (index !== -1) {
                            this.docIds.splice(index, 1);
                            this.driverData.splice(index, 1);
                        }
                    }
                }
            });
        });
    
        // Return a function to unsubscribe from real-time updates when needed
        return () => this.stopFirestoreListener();
    }
listenDriversByCompanies(companiesData: any[]) {

  this.docIds = [];
  this.driverData = [];

  // 🔥 driver_ids ka fast lookup set
  const driverSet = new Set<string>();

  companiesData.forEach(company => {
    company.driver_ids.forEach((id: string) => {
      driverSet.add(id.toString());
    });
  });

  const q = query(collection(db, "users"));

  if (this.firestoreUnsubscribe) {
    this.firestoreUnsubscribe();
    this.firestoreUnsubscribe = null;
  }

  this.firestoreUnsubscribe = onSnapshot(q, (querySnapshot) => {

    querySnapshot.docChanges().forEach((change) => {
      const docId = change.doc.id;

      // ✅ sirf wahi drivers process karo jo payload me hain
      if (driverSet.has(docId)) {

        if (change.type === "added") {
          this.docIds.push(docId);

          this.driverData.push({
            ...change.doc.data(),
            driver_id: docId
          });
        }

        if (change.type === "modified") {
          const index = this.docIds.indexOf(docId);

          if (index !== -1) {
            const driverId = docId.split('-')[1];
            const newData: any = {
              ...change.doc.data(),
              driver_id: docId
            };

            // Capture the fresh time from Firestore before we overwrite the location
            const freshFirestoreTime = newData.location?.updatedTime;

            // 🔹 Guard against stale Firestore location overwriting fresh RTDB location
            if (this.currentTrackedDriverId === driverId && this.activeWatcherInterval) {
                if (this.driverData[index] && this.driverData[index]['location']) {
                    const liveLocation = { ...this.driverData[index]['location'] };
                    if (freshFirestoreTime) {
                        liveLocation.updatedTime = freshFirestoreTime;
                    }
                    newData['location'] = liveLocation;
                }
            }

            this.driverData[index] = newData;

            // 🔥 emit updated driver unless actively tracking (prevents map reset)
            if (this.currentTrackedDriverId !== driverId || !this.activeWatcherInterval) {
                this.updateSubject.next(this.driverData[index]);
            }
          }
        }

        if (change.type === "removed") {
          const index = this.docIds.indexOf(docId);

          if (index !== -1) {
            this.docIds.splice(index, 1);
            this.driverData.splice(index, 1);
          }
        }
      }
    });

  });

  // ✅ unsubscribe function return karo
  return () => this.stopFirestoreListener();
}
  // Function to subscribe to updates
  onUpdate(): Observable<any> {
    console.log('data update ');
      return this.updateSubject.asObservable();
  }
    fetchDriverLocation(formData?:any) {
    return this.http
      .post<any>(`${this.authService._liveApiUrl}/notification/send-silent-notification/`,formData)
  }

  // --- Real-Time Database (RTDB) High-Frequency Tracking ---

  startActiveWatcher(driverId: string, targetDriverName: string = 'Unknown Driver') {
    if (this.currentTrackedDriverId === driverId && this.activeWatcherInterval) {
        // Already watching this driver
        return;
    }

    this.organizationId = this.authService.getLS('org_Id');
    this.stopActiveWatcher(); // Clear any existing watchers
    
    this.currentAdminSessionId = Math.random().toString(36).substring(2, 15);
    this.currentTrackedDriverId = driverId;

    const watcherRef = ref(rtdb, `active_watchers/${this.organizationId}/${driverId}/${this.currentAdminSessionId}`);
    
    // Register automatic cleanup on browser close or refresh
    onDisconnect(watcherRef).remove().catch(err => console.error('Failed to attach onDisconnect:', err));
    
    const adminEmail = this.authService.getLS('org_email') || 'Unknown Admin';
    const orgName = this.authService.getLS('org_domain') || 'Unknown Org';

    const watcherPayload = {
        timestamp: serverTimestamp(),
        readableTime: new Date().toLocaleString(),
        watcherId: adminEmail,
        role: `Admin Portal: ${adminEmail}`,
        orgName: orgName,
        targetDriverName: targetDriverName
    };

    // Start the heartbeat loop ONLY if the tab is visible
    if (!document.hidden) {
        this.resumeHeartbeat(watcherRef, watcherPayload);
    }

    this.currentTargetDriverName = targetDriverName;

    // Bind visibility listener to pause/resume tracking if admin switches tabs
    if (!this.visibilityListenerBound) {
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        this.visibilityListenerBound = true;
    }

    // Subscribe to live GPS stream
    const trackingRef = ref(rtdb, `tracking/${this.organizationId}/${driverId}`);
    
    // Save reference to unsubscribe if needed (Firebase v9 modular `onValue` returns an unsubscribe function)
    this.rtdbUnsubscribe = onValue(trackingRef, (snapshot) => {
        if (snapshot.exists()) {
            const data = snapshot.val();
            console.log("🔥 [LocateDriverService] RTDB GPS RECEIVED:", data); // DEBUG LOG
            const docId = `${this.organizationId}-${driverId}`;
            const index = this.docIds.indexOf(docId);
            
            // Extract the latest known Firestore timestamp we preserved in the cache
            const existingFirestoreTime = index !== -1 && this.driverData[index]?.location?.updatedTime;

            // Map the RTDB {lat, lng, heading, speed} format into our Firestore driver structure,
            // but inject the Firestore time so the UI label stays accurate per client requirements.
            const mappedData = {
                driver_id: driverId,
                location: {
                    latitude: data.lat,
                    longitude: data.lng,
                    heading: data.heading, 
                    speed: data.speed,
                    updatedTime: existingFirestoreTime || data.updatedAt // 👈 Bullet-proof fallback to Firestore
                },
                isRTDB: true // 🔹 Flag to tell map component this is high-frequency RTDB data
            };
            
            // 🔹 Keep the global driver data array in sync with fresh RTDB coords
            if (index !== -1 && this.driverData[index]) {
                this.driverData[index]['location'] = mappedData.location;
            }

            this.updateSubject.next(mappedData);
        }
    });
  }

  private pauseHeartbeat() {
      if (this.activeWatcherInterval) {
          clearInterval(this.activeWatcherInterval);
          this.activeWatcherInterval = null;
      }
      // Delete the node so the driver app knows we stopped watching
      if (this.currentTrackedDriverId && this.organizationId && this.currentAdminSessionId) {
          const watcherRef = ref(rtdb, `active_watchers/${this.organizationId}/${this.currentTrackedDriverId}/${this.currentAdminSessionId}`);
          remove(watcherRef).catch(err => console.error('Failed to remove watcher on pause:', err));
      }
  }

  private resumeHeartbeat(watcherRef: any, payload: any) {
      if (this.activeWatcherInterval) {
          clearInterval(this.activeWatcherInterval);
      }
      
      // Send immediate heartbeat
      set(watcherRef, payload);

      // Setup 30-second heartbeat loop
      this.activeWatcherInterval = setInterval(() => {
          set(watcherRef, { ...payload, timestamp: serverTimestamp(), readableTime: new Date().toLocaleString() });
      }, 30000);
  }

  stopActiveWatcher() {
    this.pauseHeartbeat();
    
    if (this.currentTrackedDriverId) {
        // Stop listening to the live GPS stream
        if (this.rtdbUnsubscribe) {
            this.rtdbUnsubscribe();
            this.rtdbUnsubscribe = null;
        } else {
            // Fallback just in case
            const trackingRef = ref(rtdb, `tracking/${this.organizationId}/${this.currentTrackedDriverId}`);
            off(trackingRef);
        }
    }
    
    this.currentTrackedDriverId = null;
    this.currentAdminSessionId = null;

    if (this.visibilityListenerBound) {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        this.visibilityListenerBound = false;
    }
  }

  stopFirestoreListener() {
      if (this.firestoreUnsubscribe) {
          this.firestoreUnsubscribe();
          this.firestoreUnsubscribe = null;
      }
  }
}